const accordionHeading = document.querySelector(".accordion-heading");
const accordionContent = document.querySelector(".accordion-content");
const icon = document.querySelector(".accordion-heading img");

if (accordionHeading && accordionContent && icon) {
  accordionHeading.addEventListener("click", () => {
    accordionContent.classList.toggle("active");
    icon.classList.toggle("active");
  });
}

const sizeHeading = document.querySelector(".size-heading");
const sizeContent = document.querySelector(".sizes-content");
const sizeIcon = document.querySelector(".size-heading img");

if (sizeHeading && sizeContent && sizeIcon) {
  sizeHeading.addEventListener("click", () => {
    sizeContent.classList.toggle("active");
    sizeIcon.classList.toggle("active");
  });
}

document.querySelectorAll('.filter__input[value="Antimicrobial/Antibacterial"]').forEach((input) => {
  const parent = input.closest('li');
  if (parent) {
    parent.remove();
  }
});


// document.addEventListener("DOMContentLoaded", () => {
//   const sizeHeading = document.querySelector(".size-heading");
//   const sizeContent = document.querySelector(".sizes-content");
//   const sizeIcon = document.querySelector(".size-heading img");
//   const body = document.querySelector("body");

//   if (body.classList.contains("e-comm-product") && sizeContent) {
//     console.log("Body has class 'e-comm-product");
//     sizeContent.style.display = "block !important";
//     sizeContent.style.overflow = "auto !important";
//     sizeContent.style.maxHeight = "auto !important";
//     if (sizeIcon) {
//       sizeIcon.classList.add("active");
//     }
//   }

//   if (sizeHeading && sizeContent && sizeIcon) {
//     sizeHeading.addEventListener("click", () => {
//       sizeContent.classList.toggle("active");
//       sizeIcon.classList.toggle("active");

//       if (sizeContent.classList.contains("active")) {
//         sizeContent.style.display = "block";
//       } else {
//         sizeContent.style.display = "none";
//       }
//     });
//   }
// });
